<template>
  <div v-if="isPromocodes" class="promocodes">
    <div class="l-container">
      <component :is="component" :data="data" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PromocodesContent } from '~/interfaces/constructor';

const Default = defineAsyncComponent(
  () =>
    import('~/components/constructor-components/promocodes/default/Default.vue')
);
const BestActions = defineAsyncComponent(
  () =>
    import(
      '~/components/constructor-components/promocodes/best-actions/BestActions.vue'
    )
);
const PopularPromocodes = defineAsyncComponent(
  () =>
    import(
      '~/components/constructor-components/promocodes/popular-promocodes/PopularPromocodes.vue'
    )
);

const Layouts: {
  [key: string]: string;
} = {
  default: Default,
  'best-actions': BestActions,
  'popular-promocodes': PopularPromocodes,
};

const props = defineProps({
  data: {
    required: true,
    type: Object as () => PromocodesContent,
  },
});

const isPromocodes = computed<boolean>(() => !!props?.data?.items?.length);

const component = computed(() => {
  return Layouts[props.data.layout] || Default;
});
</script>
<style lang="scss" src="./PromocodesScss.scss" scoped></style>
